import {
	Button,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react"
import { FC, useRef } from "react"
import { BsPrinterFill } from "react-icons/bs"
import ReactToPrint from "react-to-print"
import { IIncome } from "src/domain/entities"
import { IncomePrintView } from "./IncomePrintView"

interface Props {
	income: IIncome
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
}

export const IncomePreviewDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	income,
}) => {
	const onClose = () => setIsOpen(false)

	const printComponentRef = useRef<HTMLDivElement>(null)

	return (
		<>
			<Modal onClose={onClose} isOpen={isOpen} isCentered size={"3xl"}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Income Preview</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<IncomePrintView income={income} />
					</ModalBody>
					<ModalFooter>
						<Flex gridColumnGap={2}>
							<Button onClick={onClose}>Close</Button>
							<div ref={printComponentRef} className="printable">
								<IncomePrintView income={income} />
							</div>
							<ReactToPrint
								content={() => printComponentRef.current}
								copyStyles={true}
								trigger={() => (
									<Button
										colorScheme={"green"}
										leftIcon={<BsPrinterFill />}
									>
										Print
									</Button>
								)}
							/>
						</Flex>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	)
}
